import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initVersionGuard } from './utils/versionGuard';
import { installErrorCapture } from './services/clientReporter';

// Capture client-side errors to Firestore so the shop can SEE what breaks live. (Jose 2026-10-13)
installErrorCapture();

// Silence noisy dev logs in production; keep console.error/warn for real diagnostics.
if (process.env.NODE_ENV === 'production') {
  // eslint-disable-next-line no-console
  console.log = console.info = console.debug = () => {};
}

// Self-heal: auto-reload when a newer build is deployed (kills stale mobile-Safari cache).
initVersionGuard();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Fade out the instant pre-React splash (public/index.html #slik-splash) once React has mounted.
const splashEl = document.getElementById('slik-splash');
if (splashEl) {
  requestAnimationFrame(() =>
    requestAnimationFrame(() => {
      splashEl.style.opacity = '0';
      setTimeout(() => splashEl.remove(), 550);
    })
  );
}
